import Vue from "vue";
import Vuelidate from "vuelidate";
import VuelidateErrorExtractor, { templates } from "vuelidate-error-extractor";

import {FormGroup} from "@/components/base/index.js";

Vue.use(Vuelidate);

const messages = {
  required: "{attribute} is required.",
  alpha: "{attribute} should be characters",
  numeric: "{attribute} should be numbers.",
  email: "{attribute} should be a valid email.",
  telephone: "{attribute} Enter valid phoneno.",
  maxLength: "{attribute} should be less than {max} characters.",
  minLength: "{attribute} should be greater than {min} characters.",
  onlynumbers: "{attribute} should be only numbers.",
  countrycode: "{attribute} is invalid.",
};

Vue.use(VuelidateErrorExtractor, {
  messages,
  attributes: {
    userName: "userName",
    password: "password",
    email: "email",
    oldPassWord: "",
    // Address
    address_line1: "Address Line 1",
    address_line2: "Address Line 2",
    // Customer
    maximum_credit_amount: "Maximum Credit Amount",
    payment_term: "Payment Term",
    customer_type_id: "Customer Type",
    is_allow_exceed: "Allow Exceed",
    postal_code: "Postal Code",
    country_code: "Country",
  },
});

Vue.component("FormGroup", FormGroup);
// Vue.component("FormSummary", FormSummary);
Vue.component("formWrapper", templates.FormWrapper);
